import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { ResolverLoadEventTypes } from '../State/actions/resolver.actions';
import { getEventTypeFetched } from '../State/selectors/event-type.selector';
import { BaseEntityResolver } from './resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class EventTypeResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getEventTypeFetched, new ResolverLoadEventTypes(), store);
    }
}
